// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyAppCard_container__3ceF5","surface":"EmptyAppCard_surface__SoFe8","icon":"EmptyAppCard_icon__1b8-v","label":"EmptyAppCard_label__1T2vw"};